import axios from 'axios';
import { detect } from 'detect-browser';

import { API_URL } from '../config';
import { browserConstants } from 'z-js-commons';

export function isAxiosError(err) {
    // axios errors always have a status and a request properties
    return err.status && err.request;
}

const instance = axios.create({
    baseURL: API_URL,
    withCredentials: true
});

// Avoid using browser cache in IE
instance.interceptors.request.use(config => {
    const browser = detect();

    if (browser && browser.name === browserConstants.INTERNET_EXPLORER) {
        config.params = config.params || {};
        config.params._ = Date.now();
    }

    return config;
});

export default instance;
